import './icons.css';
import {
  faCircleExclamation, faTriangleExclamation, faArrowDown, faArrowUp,
  faCalendar, faCalendarCheck, faCalendarDays, faCheck, faCircleCheck,
  faChevronDown, faChevronRight, faChevronUp, faClipboardList, faTable, faTableColumns,
  faAddressCard, faDownload, faEuroSign, faFlask, faGraduationCap, faHashtag,
  faHouse, faCircleInfo, faLayerGroup, faFilter, faLock, faTicket,
  faRightToBracket, faRightFromBracket, faEnvelope, faLocationDot, faBars,
  faBug, faMoon, faFloppyDisk, faMagnifyingGlass, faGear, faShield, faExpand, faCompress,
  faShieldHalved, faSun, faTag, faToggleOff, faToggleOn, faUser,
  faUsers, faXmark,
} from '@fortawesome/free-solid-svg-icons';

/* ══════════════════════════════════════════
   Icons — dieselben wie auf der Website
   ──────────────────────────────────────────
   Die Website nutzt Font Awesome Free 6.5.0 (selbst gehostet, css/
   fontawesome.min.css). Das Dashboard nutzte lucide-react — zwei
   Zeichensprachen in einem Auftritt.

   Genommen ist die SVG-Fassung, nicht die Icon-Schrift: dieselben Glyphen,
   aber nur die benutzten Pfade im Bündel. Gezeichnet werden sie hier selbst
   (ausLucide unten), nicht über @fortawesome/react-fontawesome: Dessen
   Laufzeit samt fontawesome-svg-core waren 67 KB im Bündel, nur um pro
   Zeichen ein <svg> mit einem <path> zu schreiben. Die Pfade kommen
   weiterhin aus @fortawesome/free-solid-svg-icons. Die Schrift wären 133 KB
   fa-solid-900.woff2 plus 102 KB CSS für rund 45 Zeichen. Die Version ist
   auf 6.5.0 festgenagelt, weil Font Awesome mit 7 etliche Icons neu
   gezeichnet hat — einheitlich heißt: dieselbe Version wie dort.

   Die Namen bleiben die von lucide. Das ist Absicht: so ändert jede
   Aufrufstelle nur ihre Importzeile, statt dass rund 200 Stellen
   umgeschrieben werden. Die Zuordnung steht hier EINMAL.

   Nicht jedes lucide-Zeichen hat ein genaues Gegenstück in Font Awesome
   Free. Wo genähert wurde, steht es dahinter — diese bitte einmal ansehen
   und sagen, ob sie passen.

   Zwei Zuordnungen sind beim Umstellen ganz entfallen, weil die
   Aufrufstellen falsch benannt waren: der Knopf „Spalten anpassen" trug
   Schieberegler (jetzt Columns3), und der Menüpunkt „Anmeldungen" trug ein
   2x2-Raster (jetzt Ticket — es geht um Ticket-Anmeldungen).
   ══════════════════════════════════════════ */

const ZUORDNUNG = {
  AlertCircle:          faCircleExclamation,
  AlertTriangle:        faTriangleExclamation,
  ArrowDown:            faArrowDown,
  ArrowUp:              faArrowUp,
  Bug:                  faBug,
  Calendar:             faCalendar,
  CalendarCheck:        faCalendarCheck,
  CalendarDays:         faCalendarDays,
  Check:                faCheck,
  CheckCircle:          faCircleCheck,
  ChevronDown:          faChevronDown,
  ChevronRight:         faChevronRight,
  ChevronUp:            faChevronUp,
  ClipboardList:        faClipboardList,
  Columns3:             faTableColumns,      // genähert: FA hat keine Drei-Spalten-Variante
  Contact:              faAddressCard,       // genähert: Adresskarte statt Kontaktkopf
  Download:             faDownload,
  Euro:                 faEuroSign,
  FlaskConical:         faFlask,             // genähert: Rundkolben statt Erlenmeyer
  GraduationCap:        faGraduationCap,
  Hash:                 faHashtag,
  Home:                 faHouse,
  Info:                 faCircleInfo,
  Layers:               faLayerGroup,
  ListFilter:           faFilter,
  Lock:                 faLock,
  LogIn:                faRightToBracket,
  LogOut:               faRightFromBracket,
  Mail:                 faEnvelope,
  Maximize:             faExpand,            // Vollbild an (Check-in am Tisch)
  Minimize:             faCompress,          // Vollbild aus
  MapPin:               faLocationDot,
  Menu:                 faBars,
  Moon:                 faMoon,
  Save:                 faFloppyDisk,
  Table2:               faTable,
  Search:               faMagnifyingGlass,
  Settings:             faGear,
  Shield:               faShield,
  ShieldCheck:          faShieldHalved,      // genähert: geteilter Schild statt Schild mit Haken
  Sun:                  faSun,
  Tag:                  faTag,
  Ticket:               faTicket,
  ToggleLeft:           faToggleOff,
  ToggleRight:          faToggleOn,
  User:                 faUser,
  Users:                faUsers,
  X:                    faXmark,
};

/* Übersetzt die lucide-Schnittstelle auf Font Awesome.

   `size` ist bei lucide eine Kantenlänge in Pixeln; Font Awesome bemisst
   sich an der Schriftgröße und ist 1em hoch. fontSize: size ergibt also
   dieselbe Höhe.

   `fixedWidth` ist hier Standard, anders als bei Font Awesome sonst. Grund:
   lucide-Zeichen sind quadratisch, Font-Awesome-Zeichen nicht — ein Haus ist
   23 px breit, eine Personengruppe 30. Das gesamte Regelwerk des Dashboards
   ist gegen quadratische Zeichen gebaut, und ohne feste Breite standen die
   Beschriftungen in der Navigation um bis zu 5 px versetzt. fixedWidth legt
   jedes Zeichen in eine Box von 1,25em, ohne es zu verzerren. Wer die
   natürliche Breite braucht, gibt fixedWidth={false} mit.

   `strokeWidth` schluckt der Übersetzer: lucide zeichnet mit Strichen,
   Font Awesome mit Flächen, die Angabe hat dort keine Entsprechung. */

/* Alle Zeichen laufen etwas kleiner als die Zahl im Aufruf sagt.

   Der Grund ist der Wechsel von Strich auf Fläche: ein lucide-Zeichen ist bei
   size=20 eine 20 px hohe Linienzeichnung mit viel Luft darin, ein
   Font-Awesome-Zeichen bei 20 px eine gefüllte Form, die den Platz ausnutzt.
   Gleiche Höhe, deutlich mehr Gewicht — im Bild sahen sie dadurch überall zu
   groß aus. Mit dem Faktor stimmt die gefühlte Größe wieder, ohne dass 200
   Aufrufstellen angefasst werden müssen.

   Wer hier dreht, dreht an allen Icons gleichzeitig — das ist der Zweck. */
const GROESSENFAKTOR = 0.85;

/* Dasselbe Markup wie FontAwesomeIcon: <svg class="svg-inline--fa fa-fw">
   mit einem Pfad in currentColor, 1em hoch. Die Grundregeln, die Font
   Awesome sonst zur Laufzeit ins Dokument schreibt, stehen in icons.css.
   Ohne `title` ist das Zeichen Schmuck (aria-hidden), wie bei Font Awesome. */
function ausLucide(def, name) {
  const [breite, hoehe, , , pfad] = def.icon;
  const Komponente = ({ size = 24, color, className, style, strokeWidth, fixedWidth = true, title, ...rest }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${breite} ${hoehe}`}
      className={`svg-inline--fa${fixedWidth ? ' fa-fw' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden={title ? undefined : 'true'}
      role="img"
      focusable="false"
      data-icon={def.iconName}
      style={{
        fontSize: typeof size === 'number' ? `${Math.round(size * GROESSENFAKTOR)}px` : size,
        ...(color ? { color } : null),
        ...style,
      }}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path fill="currentColor" d={pfad} />
    </svg>
  );
  Komponente.displayName = name;
  return Komponente;
}

const fertig = {};
for (const [name, icon] of Object.entries(ZUORDNUNG)) fertig[name] = ausLucide(icon, name);

export const {
  AlertCircle, AlertTriangle, ArrowDown, ArrowUp, Bug, Calendar, CalendarCheck,
  CalendarDays, Check, CheckCircle, ChevronDown, ChevronRight, ChevronUp,
  ClipboardList, Columns3, Contact, Download, Euro, FlaskConical,
  GraduationCap, Hash, Home, Info, Layers,
  ListFilter, Lock, LogIn, LogOut, Mail, MapPin, Maximize, Menu, Minimize,
  Moon, Save, Search, Settings, Shield, ShieldCheck, Sun, Table2,
  Tag, Ticket, ToggleLeft, ToggleRight, User, Users, X,
} = fertig;
